import { useState, useEffect, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
function Portfolio() {
    const cover = useSelector((state) => state.counter.value)
    const [galerys, setGalerys] = useState([])
    const [inner, setInner] = useState()
    const [portfolios, setPortfolios] = useState()
    const [product, setProduct] = useState()
    const [productSelected, setProductSelected] = useState()
    const updateSize = () => {
        let parentGalery = document.getElementById('parent-galery')
        let repetition = 3
        setInner({
            value: parentGalery.getBoundingClientRect().width / repetition,
            repetition: repetition
        })
    }
    const updatePosition = (portfolio) => {
        if(portfolio && inner) {
            let width = inner.value;
            let repetition = inner.repetition;
            let position = {
                top: 0,
                left: 0
            }
            let masterHeight = [];
            portfolio.forEach((value, index) => {
                let equality = value.width / width
                let origin = value.height / equality
                let modulus = index % repetition
                let masterHeightIndex = index < repetition ? modulus : masterHeight.indexOf(Math.min(...masterHeight))
                let masterHeightModulus = masterHeight[masterHeightIndex] || 0
                position.top = masterHeightModulus
                position.left = width * masterHeightIndex
                masterHeight[masterHeightIndex] = masterHeightModulus + origin
                portfolio[index].position = {...position}
            })
            setGalerys(portfolio)
        }
    }
    let filterImage = (filterProduct) => {
        setProductSelected(filterProduct)
        let width = inner.value;
        let repetition = inner.repetition;
        let masterHeight = [];
        let indexHeight = 0;
        galerys.map((value, index) => {
            let elementImage = document.getElementById(`image${index}`)
            void elementImage.clientHeight
            if(filterProduct === 'All' || filterProduct === value.product) {
                let equality = value.width / width
                let origin = value.height / equality
                let modulus = indexHeight % repetition
                let masterHeightIndex = indexHeight < repetition ? modulus : masterHeight.indexOf(Math.min(...masterHeight))
                let masterHeightModulus = masterHeight[masterHeightIndex] || 0
                elementImage.style.opacity = 1
                elementImage.style.left = `${width * masterHeightIndex}px`;
                elementImage.style.top = `${masterHeightModulus}px`;
                masterHeight[masterHeightIndex] = masterHeightModulus + origin
                indexHeight++;
            }
            else {
                elementImage.style.opacity = 0
            }
        });
    }
    const galeryHtml = galerys?.map((value, index) => {
        let elementImage = document.getElementById(`image${index}`)
        if(elementImage) {
            elementImage.addEventListener('animationend', () => {
                elementImage.classList.remove("animation1");
            }, { once: true });
        }
        let position = value.position
        return (
            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app animation1" style={{left: position.left, "--start": `${position.top - 10}px`, "--end": `${position.top}px`, top: position.top}} key={index} id={`image${index}`} >
                <img src={value.fileName} className="img-fluid" alt="" />
            </div>
        )
    })
    const productHtml =  product?.map((value, index) => {
        let className = productSelected === value ? 'filter-active': ''
        return (
            <>
                <li className={className} onClick={() => filterImage(value)}>{value}</li>
            </>
        )
    })
    useEffect(() => {
        let payload = cover?.payload;
        if(payload) {
            let counter = 1;
            let lenght = payload.portfolio.length
            let portfolio =  []
            let products = ['All']
            setProductSelected(products[0])
            payload.portfolio.forEach((value, index) => {
                let bgImg = new Image()
                let valueProduct = value.product
                if(!products.includes(valueProduct)) {
                    products.push(valueProduct)
                }
                bgImg.src = value.fileName
                bgImg.id = index
                bgImg.dataset.product = valueProduct
                bgImg.onload = function() {
                    const id = this.id;
                    portfolio[id] = {
                        id: id,
                        fileName: this.src,
                        width: this.width,
                        height: this.height,
                        product: this.dataset.product
                    };
                    if(counter === lenght) {
                        setPortfolios(portfolio)
                    }
                    counter++
                }
            })
            setProduct(products)
        }
    }, [cover]);
    useEffect(() => {
        updatePosition(portfolios)
    }, [portfolios, inner]);
    useLayoutEffect(() => {
        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return (
        <section id="portfolio" className="portfolio section">
            <div className="container">
                <div className="isotope-layout">
                    <ul className="portfolio-filters isotope-filters aos-init aos-animate">
                        {productHtml}
                        {/* <li className="filter-active">All</li>
                        <li>App</li>
                        <li>Card</li>
                        <li>Web</li> */}
                    </ul>
                    <div className="row gy-4 isotope-container aos-init aos-animate" id="parent-galery" style={{height: "1249.08px"}}>
                        {galeryHtml}
                    </div>
                </div>
            </div>
        </section>
    );
}
export default Portfolio;